var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gtr-load-micro-error"},[_c('pb-empty',{attrs:{"description":_vm.message}},[_c('pb-button',{attrs:{"type":"danger"},on:{"click":function($event){return _vm.$emit('reload')}}},[_vm._v(" "+_vm._s(_vm.$t('FoodB_statistics_Refresh_qDDP'))+" ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }